import React from 'react';
import NProgress from 'nprogress';
import { Modal } from '@avila-tek/ui/src';
import { useRouter } from 'next/router';
import { useMutation } from '@apollo/client';
import { ProductItem } from '../../shared/AssignModal';
import { Plan, ShopCart, ShopItem, User } from '../../../models';
import { useNotify, useShopCart } from '../../../hooks';
import { ADD_ITEM_TO_SHOP_CART } from '../../../graphql/mutation';
import SubscriptionInputs from './SubscriptionInputs';
import EmployeeList from '../../shared/AssignModal/EmployeeList/EmployeeList';
import TotalItem from '../../shared/AssignModal/TotalItem';
import AssignModalButtons from '../../shared/AssignModal/AssignModalButtons';

interface AddSubscriptionModalProps {
  isOpen: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  plans: Plan[];
}

function AddSubscriptionModal({
  isOpen,
  setOpen,
  plans,
}: AddSubscriptionModalProps) {
  const router = useRouter();
  const notify = useNotify();
  const [shopCart, setShopCart] = useShopCart();

  const [planSelected, setPlanSelected] = React.useState<Partial<Plan>>({});
  const [shopList, setShopList] = React.useState<ShopItem[]>([]);
  const [disabled, setDisabled] = React.useState(false);

  const [addItemToShopCartMutation] = useMutation<{
    addItemToShopCart: ShopCart;
  }>(ADD_ITEM_TO_SHOP_CART);

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    try {
      e.preventDefault();
      if (disabled) return;
      NProgress.start();
      setDisabled(true);

      if (!planSelected._id) notify('Debe seleccionar un plan', 'error');

      if (!shopList.length)
        notify('Debe seleccionar al menos un cliente', 'error');

      if (planSelected.frequencies.length < 1)
        notify('Debe seleccionar al menos una frecuencia', 'error');
      const { data } = await addItemToShopCartMutation({
        variables: {
          data: {
            shopCart: shopCart._id,
            items: [
              {
                plan: planSelected._id,
                frequency: planSelected.frequencies[0].time,
                shopList: shopList.map((c) => ({
                  client: (c.client as User)?.client?._id,
                  quantity: 1,
                })),
              },
            ],
          },
        },
      });
      if (data?.addItemToShopCart?._id) {
        notify('Se ha agreagado al carrito con éxito', 'success');
        setShopCart(data?.addItemToShopCart);
      } else {
        notify('Ha ocurrido un error al intentar agregar al carrito', 'error');
      }
      router.push('/app/shopcart');
    } catch (error) {
      console.log(error);
      notify(error.message, 'error');
    } finally {
      setDisabled(false);
      NProgress.done();
    }
  };

  const getTotalQuantity = () => {
    let total = 0;
    shopList.forEach((c) => {
      total += c.quantity;
    });
    return total;
  };

  return (
    <Modal
      isOpen={isOpen}
      setOpen={setOpen}
      className="md:max-w-[60%] md:ml-72 "
    >
      <form method="POST" onSubmit={onSubmit}>
        <div className="bg-white rounded-lg ">
          <Modal.Title title="Adquirir suscripciones" setIsOpen={setOpen} />
          <div className="flex flex-col p-6">
            {/* description */}
            <span className="text-text-gray">
              Asigna un plan a tus beneficiarios y clientes para que puedan
              disfrutar de los beneficios de la suscripción!
            </span>
            <SubscriptionInputs
              plans={plans}
              planSelected={planSelected}
              setPlanSelected={setPlanSelected}
            />
            <EmployeeList
              shopList={shopList}
              setShopList={setShopList}
              type="plan"
            />
            <div className="w-full flex flex-col mt-5">
              <ProductItem
                title="Subscripciones"
                subtitle={planSelected.title}
                quantity={getTotalQuantity()}
                price={
                  planSelected?.frequencies?.length > 0
                    ? planSelected?.frequencies[0]?.price
                    : 0
                }
              />
            </div>
            <TotalItem
              total={
                planSelected?.frequencies?.length > 0
                  ? (planSelected?.frequencies[0]?.price ?? 0) *
                    getTotalQuantity()
                  : 0
              }
            />
            <AssignModalButtons />
          </div>
        </div>
      </form>
    </Modal>
  );
}

export default AddSubscriptionModal;
